// Which kind of task this is, worked out from existing fields only (no data migration).
// Order matters:
//  1. Manual: added by hand (manual: true, source 'manual' or 'crm-lead-task' = "Add task" on a lead).
//  2. Pipeline: tied to a buyer/seller interest (buyerInterestId / sellerInterestId, or a buyer-interest* / seller-interest* source).
//  3. Transaction: on a deal (source 'transaction', a transactionId, or read from transactions/{id}/tasks).
//  4. Lead follow-up: generated for a lead/contact (crm-* sources such as campaigns, callbacks, re-engage, appointments;
//     boldtrail; referral follow-ups; or any other task that carries crmContactId/contactId).
//  5. Anything else (no source, routine tasks, unknown sources) falls back to Manual.
export const TASK_KINDS = {
  transaction: { label: 'Transaction', bg: '#EAF1FB', fg: '#1F4E8C', border: '#BCD0EE' },
  pipeline: { label: 'Pipeline', bg: '#F3ECFA', fg: '#5B2E8C', border: '#D7C3EE' },
  lead: { label: 'Lead follow-up', bg: '#E8F5EE', fg: '#1E6B43', border: '#BFE2CD' },
  manual: { label: 'Manual', bg: '#F4F1EA', fg: '#5B4A1F', border: '#E0D6BE' },
};

const MANUAL_SOURCES = ['manual', 'crm-lead-task'];

export function taskKind(task = {}, { path = '' } = {}) {
  const t = task || {};
  const source = String(t.source || '').toLowerCase();
  if (t.manual === true || MANUAL_SOURCES.includes(source)) return 'manual';
  if (t.buyerInterestId || t.sellerInterestId || /^(buyer|seller)-interest/.test(source)) return 'pipeline';
  if (source === 'transaction' || t.transactionId || /^transactions\//.test(path)) return 'transaction';
  if (/^crm-/.test(source) || source === 'boldtrail' || source === 'referral' || t.crmContactId || t.contactId) return 'lead';
  return 'manual';
}

export const taskKindInfo = (task, opts) => TASK_KINDS[taskKind(task, opts)];
